module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "SOM",
    attrs: {
      "epub:type": "toc",
      "role": "doc-toc"
    }
  }, [_c('h1', {
    staticClass: "SOM_titre",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre2"
    }
  }, [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ETTING THE")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OST")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UT OF")]), _vm._v(" "), _c('i', [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRISTIAN")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMUNITY")])])])]), _vm._v(" "), _c('div', {
    staticClass: "table",
    attrs: {
      "id": "tableau-001"
    }
  }, [_c('div', {
    staticClass: "table-align"
  }, [_c('table', {
    staticStyle: {
      "border-collapse": "collapse",
      "border-spacing": "0px"
    },
    attrs: {
      "border": ""
    }
  }, [_c('colgroup', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('col', {
    staticStyle: {
      "width": "3%",
      "padding": "2px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "55%",
      "padding": "2px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "25%",
      "padding": "2px"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "bottom"
    }
  }, [_c('p', {
    staticClass: "SOM_chap2"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1"
    }
  }, [_c('b', [_vm._v("1")])])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1"
    }
  }, [_c('b', [_vm._v("Built to Last")])])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1"
    }
  }, [_c('span', {
    staticClass: "mev3"
  }, [_vm._v("Ephesians 2:11-22")])])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "bottom"
    }
  }, [_c('p', {
    staticClass: "SOM_chap2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("2")])])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Everyone’s Involved")])])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev3"
  }, [_vm._v("1 Corinthians 12")])])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "bottom"
    }
  }, [_c('p', {
    staticClass: "SOM_chap2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("3")])])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Everyone’s Invited")])])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev3"
  }, [_vm._v("Philemon")])])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "bottom"
    }
  }, [_c('p', {
    staticClass: "SOM_chap2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("4")])])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("We Gather Together")])])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev3"
  }, [_vm._v("Psalm 100")])])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "bottom"
    }
  }, [_c('p', {
    staticClass: "SOM_chap2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("5")])])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Community Commissioned")])])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev3"
  }, [_vm._v("Luke 10:1-20")])])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "bottom"
    }
  }, [_c('p', {
    staticClass: "SOM_chap2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("6")])])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Servant’s Entrance")])])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev3"
  }, [_vm._v("Matthew 25:31-46")])])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "bottom"
    }
  }, [_c('p', {
    staticClass: "SOM_chap2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("7")])])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("And They’ll Know We Are Christians")])])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev3"
  }, [_vm._v("John 13:1-17, 34-35")])])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "bottom"
    }
  }, [_c('p', {
    staticClass: "SOM_chap2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("8")])])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("True Confessions")])])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev3"
  }, [_vm._v("Nehemiah 9:1-5; James 5:13-20")])])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "bottom"
    }
  }, [_c('p', {
    staticClass: "SOM_chap2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap9",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("9")])])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap9",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Confrontation & Restoration")])])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev3"
  }, [_vm._v("Matthew 18:15-35")])])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "bottom"
    }
  }, [_c('p', {
    staticClass: "SOM_chap2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap10",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("10")])])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap10",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("A Haven for Healing")])])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev3"
  }, [_vm._v("Ezekiel 34:1-16")])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Leader’s Notes")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pdf"
  }, [_c('span', {
    attrs: {
      "href": "#/fin_acheve",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Titles from InterVarsity Press")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-029e4e6e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sommaire.vue
// module id = 60
// module chunks = 0